import React from 'react';

import { IWidgetBlockComponent } from '../types/IWidgetBlock';
import { Container } from './StaticImage.style';
import { StaticImageModel } from './types';

const StaticImage: React.FC<IWidgetBlockComponent<StaticImageModel>> = ({ widgetModel }) => {
    if (!widgetModel) {
        return null;
    }

    const { imageDatums: src = '' } = widgetModel;

    return (
        <Container className='staticImage staticImageRender'>
            <img src={src} />
        </Container>
    );
};

export default StaticImage;
